import {
  create
} from "zustand";

interface ScrollState {
  positions: Record<string, number>;
  savePosition: (path: string, position: number) => void;
  getPosition: (path: string) => number;
}

export const useScrollStore = create<ScrollState>((set, get) => ({
  positions: {},
  savePosition: (path, position) => set((state) => ({
    positions: {
      ...state.positions, [path]: position 
    } 
  })),
  getPosition: (path) => get().positions[path] || 0
}));

